module.exports = __webpack_public_path__ + "static/img/Dinerclub.5e6c3381.svg";